<template>
    <div>
        <v-form class="form-data pb-10" @submit.prevent="onChange">
            <template v-if="!isImportSuccess">
                <v-row class="pa-8" justify="center">
                    <v-col cols="12" lg="8">
                        <label class="font-weight-medium fiord--text">Batch Number </label>
                        <v-text-field v-model="form.batch_number" id="batch_number" value="NA" :class="['mt-3', { 'is-invalid': errors.batch_number }]" :error-messages="errors.batch_number" solo dense></v-text-field>
                    </v-col>
                    <v-col cols="12" lg="8" class="text-center">
                        <div class="pa-4 white text-no-wrap rounded-lg" @dragover.prevent @drop.prevent="drop">
                            <label for="fileAssets">
                                <div class="pa-16 white text-no-wrap rounded-lg dashed-border">
                                    <svg width="69" height="70" viewBox="0 0 69 70" fill="none" xmlns="http://www.w3.org/2000/svg" class="file-import">
                                        <path
                                            d="M33.7301 0H9.25C6.79675 0 4.44397 0.974551 2.70926 2.70926C0.97455 4.44397 0 6.79675 0 9.25V51.75C0 54.2033 0.97455 56.556 2.70926 58.2907C4.44397 60.0254 6.79675 61 9.25 61H46.25C48.7033 61 51.056 60.0254 52.7907 58.2907C54.5254 56.556 55.5 54.2033 55.5 51.75V18.7699C55.4997 17.5433 55.0123 16.3672 54.1449 15.5L37 1.35512C36.1328 0.487709 34.9567 0.000261948 33.7301 0Z"
                                            :fill="currentState.color"
                                        />
                                        <rect x="6.75" y="23" width="17.6098" height="7" rx="2" fill="white" />
                                        <rect x="6.75" y="36" width="17.6098" height="7" rx="2" fill="white" />
                                        <rect x="30.3599" y="23" width="17.6098" height="7" rx="2" fill="white" />
                                        <rect x="30.3599" y="36" width="17.6098" height="7" rx="2" fill="white" />
                                        <circle cx="56" cy="57" r="11" :fill="currentState.color" stroke="white" stroke-width="4" />
                                        <template v-if="currentState.state == 2">
                                            <path d="M56.0001 58L56.0001 53" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                            <path d="M56.0001 61.5L56.0001 61" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                        </template>
                                        <template v-else-if="currentState.state == 3">
                                            <path d="M53 57.1362L55.716 59.8522L60.8523 54.7158" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                        </template>
                                        <template v-else>
                                            <path
                                                d="M55.7046 57.0001H51.8636M55.7046 53.1592V57.0001V53.1592ZM55.7046 57.0001V60.841V57.0001ZM55.7046 57.0001H59.5455H55.7046Z"
                                                stroke="white"
                                                stroke-width="2"
                                                stroke-linecap="round"
                                                stroke-linejoin="round"
                                            />
                                        </template>
                                    </svg>

                                    <!-- initial state -->
                                    <template v-if="currentState.state == 0">
                                        <input type="file" name="fileAssets" id="fileAssets" @change="onChange" ref="fileAssets" accept=".csv,.jpg" hidden />
                                        <template v-if="!hasSelectedFile">
                                            <h2 class="pt-7 pb-1 import-title label--text">Select a CSV file to import</h2>
                                            <h4 class="gray--text font-salt pb-15">or drag and drop it here</h4>
                                            <h4 class="gray--text font-salt font-weight-regular font-italic">Maximum to Upload is 500 records</h4>
                                        </template>
                                        <template v-else>
                                            <h4 class="gray--text pb-15">File selected: {{ (form.fileList[0] || {}).name }}</h4>
                                            <span class="v-btn v-btn--outlined v-btn--text theme--light v-size--default"> Change File</span>
                                        </template>
                                        <!-- <i class="red--text" v-if="errors.import_file">{{ errors.import_file }}</i> -->
                                    </template>

                                    <template v-else>
                                        <!-- uploading state -->
                                        <v-row class="pt-12 pb-6" align="center" justify="space-between">
                                            <v-col xs="12" sm="8">
                                                <p class="import-title text-left font-weight-bold mb-0">Uploading '{{ (form.fileList[0] || {}).name }}'</p>
                                                <!-- <caption class="font-weight-light" style="color: #718096" v-if="currentState.state == 1">
                                                   {{
                                                        form.fileList.length != 0 ? formatAllocation(form.fileList[0].size) : '0MB'
                                                    }}
                                                    of 2MB
                                                </caption> -->
                                                <caption class="text-body-2 red--text font-salt" v-if="currentState.state == 2">
                                                    {{
                                                        this.form.error || 'Invalid file(s). Please check file upload requirements.'
                                                    }}
                                                </caption>
                                                <caption class="green--text" v-else-if="currentState.state == 3">
                                                    Upload Complete!
                                                </caption>
                                            </v-col>
                                            <v-col xs="12" sm="4" class="text-right">
                                                <label for="changeFile" v-if="currentState.state >= 2">
                                                    <input type="file" name="changeFile" id="changeFile" @change="onChange" ref="fileAssets" accept=".csv,.jpg" hidden />
                                                    <!-- v-btn not working for file selection -->
                                                    <span class="v-btn v-btn--block v-btn--outlined v-btn--text theme--light v-size--default label--text font-weight-semi-bold"> Change File</span>
                                                </label>
                                                <v-btn class="label--text font-weight-semi-bold" default outlined block text @click.native.prevent.stop.capture="resetForm()" v-else>Cancel</v-btn>
                                            </v-col>
                                        </v-row>
                                        <v-row class="px-3 pb-12">
                                            <v-progress-linear
                                                :color="currentState.progressbar"
                                                :indeterminate="currentState.state == 1 ? true : false"
                                                :value="currentState.state != 1 ? '100' : '0'"
                                                rounded
                                                height="6"
                                            ></v-progress-linear>
                                        </v-row>
                                    </template>
                                </div>
                            </label>
                        </div>
                    </v-col>
                </v-row>
                <p class="import-guide-header font-salt text-center mt-3 mb-6">
                    Read our Import Guidelines or
                    <a :href="`${origin}/templates/merchants_import_template.csv`" target="_blank" class="import-guide primary--text font-weight-semi-bold">download a CSV</a> Template to get started.
                </p>
                <v-row class="pa-4 pb-0" justify="center">
                    <v-col cols="12" md="6" class="font-salt rounded-lg guideline-box align-center py-5 px-10">
                        <span class="guideline-title">Guidelines:</span>
                        <ol class="my-2">
                            <li class="guidelines-list py-1 text-subtitle-2">Ensure that all fields are correct and complete</li>
                            <li class="guidelines-list py-1 text-subtitle-2">Maximum to Upload is 500 records</li>
                            <li class="guidelines-list py-1 text-subtitle-2">File should be in "CSV" format</li>
                        </ol>
                    </v-col>
                </v-row>
            </template>
            <template v-else>
                <v-container fluid class="py-8 px-10">
                    <div class="d-flex mb-5">
                        <div>
                            <h3 class="label--text font-salt">Here’s a preview of your newly imported {{ classification == 'BRANCH' ? 'Branches' : 'Merchants' }}</h3>
                            <p class="gray--text font-salt">We’ll create a generated QR in your list for each row below</p>
                        </div>
                        <div class="ml-auto">
                            <v-btn color="#425466" :class="[{ disabled: isDisabledDownloadButton }, 'btn-min-width white--text no-text-transform']" height="45" @click="onDownloadAllQR">
                                <v-icon left>mdi-tray-arrow-down</v-icon> Download All QR
                            </v-btn>
                        </div>
                    </div>

                    <!-- <MerchantsDataTable module="import" :batch-number="form.batch_number" :classification="classification" :per-page="Number(form.per_page)" /> -->
                    <MerchantsDataTable module="import" :perPage="form.per_page" :customFilters="customFilters" />
                </v-container>
            </template>
        </v-form>

        <!-- <v-alert v-model="alert" close-text="Close" max-width="500" class="import-success-alert ml-auto" close-icon="close" dark dismissible v-if="isImportSuccess">
            <div class="font-weight-medium"><v-icon color="success" left>mdi-checkbox-marked-circle-outline</v-icon>Successfully imported Merchants from CSV</div>
            <div class="ml-8 time text-subtitle-2 font-weight-regular">Just now</div>
        </v-alert> -->

        <v-dialog v-model="errorDialog.show" scrollable max-width="540" color="primaryBackgroundColor" transition="scroll-y-reverse-transition" persistent>
            <v-card class="confirm-dialog">
                <v-card-title class="pb-3 font-weight-bold red--text"> <v-icon color="red" left>mdi-alert-circle</v-icon> Upload Error </v-card-title>
                <v-card-text class="pb-2">
                    <p class="font-size-21 ma-0 fiord--text">You can only upload 1 file at a time.</p>
                </v-card-text>
                <v-card-actions>
                    <v-container fluid>
                        <v-btn class="btn-min-width font-weight-bold no-text-transform" @click="modalAction({ action: 'cancel' })" height="45" block outlined text> Okay </v-btn>
                    </v-container>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog v-model="fileValidation.show" scrollable max-width="540" color="primaryBackgroundColor" transition="scroll-y-reverse-transition" persistent>
            <v-card class="confirm-dialog">
                <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                        <v-icon class="dialog-close" v-on="on" @click="fileValidation.show = false" :disabled="errorDialog.loading">mdi-close</v-icon>
                    </template>
                    <span>Close</span>
                </v-tooltip>
                <v-card-title class="pb-2 font-weight-bold label--text"> File Validation </v-card-title>
                <v-card-text class="pb-2 file-validation-details">
                    <p>Successfully uploaded file ‘{{ (form.fileList[0] || {}).name }}’</p>
                    <div class="file-validation-detail">
                        <div>File Name:</div>
                        <div>{{ (form.fileList[0] || {}).name }}</div>
                    </div>
                    <div class="file-validation-detail">
                        <div>Total Line Count:</div>
                        <div>{{ unvalidatedMerchants.total_data_rows }}</div>
                    </div>
                    <div class="file-validation-detail">
                        <div>Validated Count:</div>
                        <div :class="unvalidatedMerchants.total_valid_data ? 'green--text' : 'error--text'">{{ unvalidatedMerchants.total_valid_data }}</div>
                    </div>
                    <div class="file-validation-detail">
                        <div>Error Count:</div>
                        <div :class="{ 'error--text': unvalidatedMerchants.total_invalid_data != 0 }">{{ unvalidatedMerchants.total_invalid_data }}</div>
                    </div>
                </v-card-text>
                <v-card-actions>
                    <v-container fluid>
                        <v-row align="center" justify="center">
                            <v-col cols="6" class="d-flex justify-center">
                                <v-btn
                                    class="btn-min-width no-text-transform label--text font-weight-semi-bold"
                                    :disabled="unvalidatedMerchants.total_invalid_data == 0"
                                    @click="
                                        modalAction({
                                            action: 'view-errors',
                                            data: fileValidation.data
                                        })
                                    "
                                    height="45"
                                    block
                                    text
                                    outlined
                                >
                                    View Errors
                                </v-btn>
                            </v-col>
                            <v-col cols="6" class="d-flex justify-center">
                                <v-btn
                                    :class="[
                                        'confirm-btn btn-min-width font-weight-bold no-text-transform font-weight-semi-bold',
                                        { disabled: unvalidatedMerchants.total_invalid_data > 0 || unvalidatedMerchants.total_valid_data <= 0 }
                                    ]"
                                    color="primary"
                                    :loading="fileValidation.loading"
                                    @click="
                                        modalAction({
                                            action: 'save-validated',
                                            data: fileValidation.data
                                        })
                                    "
                                    depressed
                                    height="45"
                                    block
                                >
                                    Save Validated
                                </v-btn>
                            </v-col>
                        </v-row>
                    </v-container>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog v-model="errorDataTable.show" scrollable max-width="1200" color="primaryBackgroundColor" transition="scroll-y-reverse-transition" persistent>
            <v-card class="confirm-dialog error-dialog pa-0">
                <v-card-title class="pa-3 font-weight-bold">
                    <v-container class="title-container d-flex align-center">
                        <div class="error--text font-weight-semi-bold">{{ inValidCount }} Error<span v-if="inValidCount > 1">s</span> found</div>
                        <div class="ml-auto">
                            <v-btn color="fiord" class="btn-min-width white--text no-text-transform" height="45" :loading="isExtractLoading" @click="onExtractErrors()">
                                <v-icon left>mdi-tray-arrow-down</v-icon> Extract all Errors
                            </v-btn>
                        </div>
                        <div class="d-flex ml-3">
                            <v-tooltip bottom>
                                <template v-slot:activator="{ on }">
                                    <v-icon class="close-btn" v-on="on" @click="errorDataTable.show = false" :disabled="errorDataTable.loading">mdi-close</v-icon>
                                </template>
                                <span>Close</span>
                            </v-tooltip>
                        </div>
                    </v-container>
                </v-card-title>
                <v-card-text>
                    <v-card elevation="1">
                        <div v-if="hasErrors">
                            <!-- Component: Use merchant datatable -->
                            <v-data-table
                                class="custom-table-ui no-loading-bar"
                                item-key="lines"
                                :headers="dataTable.headers"
                                :items="dataTable.data"
                                :loading="dataTable.loading"
                                :items-per-page="inValidCount"
                                loader-height="0"
                                loading-text="Loading data..."
                                hide-default-footer
                            >
                                <template v-slot:body="{ items, headers }">
                                    <tbody>
                                        <tr v-for="rows in items" :key="rows.lines">
                                            <td v-for="(header, i) in headers" :key="i" class="py-3">
                                                <v-menu
                                                    content-class="speech-bubble"
                                                    color="white"
                                                    v-if="rows.errors && rows.errors[header.actual_value]"
                                                    open-on-click
                                                    open-on-hover
                                                    right
                                                    offset-x
                                                    nudge-right="20"
                                                    close-delay="100"
                                                >
                                                    <template v-slot:activator="{ on: menu, attrs }">
                                                        <div class="d-flex justify-space-between error--text" v-bind="attrs" v-on="{ ...menu }" style="min-width: '500px;'">
                                                            <span v-if="header.actual_value == 'mobile'">{{ rows.values[header.actual_value] | formatMobileNumber('+63') }}</span>
                                                            <span v-else>{{ rows.values[header.actual_value] }}</span>

                                                            <v-icon color="error" class="text-body-2" small right>mdi-information-outline</v-icon>
                                                        </div>
                                                    </template>

                                                    <div class="pa-5">
                                                        <div v-html="rows.errors[header.actual_value].join('<br />')"></div>
                                                    </div>
                                                </v-menu>
                                                <template v-else>
                                                    <span v-if="header.actual_value == 'classification'">{{ classification }}</span>
                                                    <span v-else-if="header.actual_value == 'batch_number'">{{ form.batch_number }}</span>
                                                    <span v-else-if="header.actual_value == 'mobile'">{{ rows.values[header.actual_value] | formatMobileNumber('+63') }}</span>
                                                    <span v-else-if="['created_at', 'activate_at', 'deactivate_at'].includes(header.actual_value)">{{ rows.values[header.actual_value] | formatDate }}</span>
                                                    <span v-else> {{ rows.values[header.actual_value] }}</span>
                                                </template>
                                            </td>
                                        </tr>
                                    </tbody>
                                </template>
                            </v-data-table>
                        </div>
                        <div v-else class="error-empty d-flex align-center justify-center text-center pa-10">
                            <div>
                                <v-icon large>mdi-account-supervisor</v-icon>
                                <div class="font-weight-bold">There are no Users to display.</div>
                                <small>You’ve not added any user yet.</small>
                            </div>
                        </div>
                    </v-card>
                </v-card-text>
                <v-card-actions> </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import MerchantsDataTable from '@/components/Merchant/DataTable.vue';

export default {
    name: 'ImportForm',
    components: {
        MerchantsDataTable
    },
    props: {
        classification: String,
        reset: Boolean,
        isImportSuccess: Boolean
    },
    data() {
        return {
            alert: true,
            form: {
                fileList: [],
                batch_number: ''
            },
            customFilters: {
                classification: { show: true, disabled: true, value: '' },
                batchNumber: { show: true, disabled: true, value: '' },
                actions: { show: false, disabled: false }
            },
            currentState: {},
            states: [
                {
                    state: 0, // Initial State
                    color: '#ACB6C6',
                    progressbar: '#E4E4E4'
                },
                {
                    state: 1, // Uploading State
                    color: '#4C6FFF',
                    progressbar: 'primary'
                },
                {
                    state: 2, // Error State
                    color: '#D43B1B',
                    progressbar: '#E4E4E4'
                },
                {
                    state: 3, // Success State
                    color: '#27AE60',
                    progressbar: '#27AE60'
                }
            ],
            hasErrors: true,
            dataTable: {
                loading: false,
                search: '',
                itemLength: 10,
                currentPage: 1,
                totalPages: 1,
                selected: [],
                sortBy: [],
                sortDesc: [],
                headers: [
                    { text: 'Partner Name', value: 'values.partner', fixed: true },
                    // { text: 'QR ID', value: 'values.id' },
                    { text: 'Store Name', value: 'values.name' },
                    { text: 'Mobile Number', value: 'values.mobile', width: '180' },
                    { text: 'Merchant Address', value: 'values.address' },
                    // { text: 'Status', value: 'values.status' },
                    { text: 'Municipality', value: 'values.municipality' },
                    { text: 'Province', value: 'values.province' },
                    { text: 'Location', value: 'values.location' },
                    { text: 'Min Points', value: 'values.min_points', tooltip: 'Minimum points required to avail the rewards or promotion.' },
                    { text: 'Type', value: 'values.type' },
                    { text: 'Classification', value: 'values.classification' },
                    { text: 'Batch Number', value: 'values.batch_number' },
                    { text: 'Longitude ', value: 'values.longitude' },
                    { text: 'Latitude ', value: 'values.latitude' },
                    { text: 'Primary (if branch)', value: 'values.primary_merchant_name' },
                    { text: 'Enrollment Date', value: 'values.created_at' },
                    { text: 'Activation Date', value: 'values.activate_at' },
                    { text: 'Deactivation Date', value: 'values.deactivate_at' }
                ],
                data: []
            },
            errorDialog: { show: false, action: '', data: {}, status: '', loading: false },
            fileValidation: { show: false, action: '', data: {}, status: '', loading: false },
            errorDataTable: { show: false, action: '', data: {}, status: '', loading: false },
            isExtractLoading: false,
            hasSelectedFile: false
        };
    },
    created() {
        // if (this.$route.query.batch_number) {
        //     this.form.batch_number = this.$route.query.batch_number;
        //     this.form.per_page = this.$route.query.per_page;
        //     this.isImportSuccess = true;
        //     this.currentState = this.states[3];
        // } else {
        this.resetForm();
        //}
    },
    computed: {
        origin() {
            const url = process.env.VUE_APP_BASE_API;
            let location = new URL(url);

            return location.origin;
        },
        inValidCount() {
            return this.unvalidatedMerchants.total_invalid_data;
        },
        isDisabledDownloadButton() {
            return this.$cookies.get('asyncTaskIDPoll') && this.$cookies.get('asyncTaskIDPoll') != null;
        },
        unvalidatedMerchants() {
            return { ...this.$store.getters['merchants/getUnvalidatedMerchants'] };
        },
        merchantsList() {
            return this.$store.getters['merchants/getMerchantsList'];
        }
    },
    watch: {
        reset: {
            immediate: true,
            handler(value) {
                if (value) {
                    this.resetForm();
                }
            }
        },
        unvalidatedMerchants(value) {
            this.dataTable.headers.map((header) => {
                header.actual_value = header.value.replace('values.', '');
                header.tooltip = false;
            });

            if (value.rows) this.dataTable.data = [...value.rows];
        }
    },
    methods: {
        modalAction({ action }) {
            switch (action) {
                case 'cancel':
                    this.errorDialog.show = false;
                    break;

                case 'view-errors':
                    this.errorDialog.show = false;
                    this.errorDataTable.show = true;
                    break;

                case 'save-validated':
                    this.fileValidation.loading = true;
                    this.onSaveValidatedFile();
                    break;
            }
        },
        onChange() {
            this.form.fileList = [...this.$refs.fileAssets.files];

            if ((this.form.fileList[0].size / 1024 / 1024).toFixed(4) > 2) {
                this.currentState = this.states[2];
                this.form.error = 'Maximum file size is 2MB';
            } else {
                // console.log('file received', this.form.fileList);
                //this.hasSelectedFile = true;
                this.currentState = this.states[1];

                const formData = new FormData();
                formData.append('batch_number', this.form.batch_number);
                formData.append('import_file', this.form.fileList[0]);

                this.customFilters.batchNumber.value = this.form.batch_number;
                this.customFilters.classification.value = this.classification;
                if (this.classification == 'BRANCH') {
                    this.onImportBranches(formData);
                } else {
                    this.onImportPrimaryMerchants(formData);
                }
            }
        },
        drop(e) {
            // console.log(e.dataTransfer.files);

            // If dropped files are more than 1, show error
            if (e.dataTransfer.files.length > 1) {
                this.errorDialog.show = true;
            } else {
                let dtObject = new DataTransfer();
                dtObject.items.add(e.dataTransfer.files[0]);
                this.$refs.fileAssets.files = dtObject.files;
                this.onChange();
            }
        },
        formatAllocation(bytes) {
            if (bytes === 0) return '0Bytes';

            const k = 1024;
            const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
            const i = Math.floor(Math.log(bytes) / Math.log(k));
            const dm = i <= 2 ? 0 : 2;
            const converted = parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + sizes[i];
            return converted;
        },
        resetForm() {
            this.currentState = this.states[0];
            this.$store.commit('merchants/SET_IMPORT_SUCCESS', false);
            this.form = { fileList: [], batch_number: '' };

            const query = Object.assign({}, this.$route.query);
            delete query.batch_number;
            delete query.per_page;
            this.$router.replace({ query });
            this.$api.cancelCurrentApiCall();
        },
        onImportBranches(formData) {
            let path = '/merchants/view';
            if (this.$route.path.indexOf('merchants') == -1 && this.$route.path.indexOf('branches') != -1) {
                path = '/branches/view';
            }

            this.$store
                .dispatch('merchants/importBranchMerchants', {
                    id: this.$route.params.id || this.userInfo.merchant.uuid,
                    path: path,
                    data: formData,
                    config: {
                        headers: {
                            'Content-Type': 'multipart/form-data'
                        }
                    }
                })
                .then(() => {
                    this.currentState = this.states[3];
                    this.fileValidation.show = true;
                })
                .catch(() => {
                    if ('import_file' in this.errors) {
                        this.currentState = this.states[2];
                        this.form.error = this.errors.import_file;
                    } else {
                        this.currentState = this.states[0];
                    }
                });
        },
        onImportPrimaryMerchants(formData) {
            this.$store
                .dispatch('merchants/importPrimaryMerchants', {
                    data: formData,
                    config: {
                        headers: {
                            'Content-Type': 'multipart/form-data'
                        }
                    }
                })
                .then(() => {
                    this.currentState = this.states[3];
                    this.fileValidation.show = true;
                })
                .catch(() => {
                    if ('import_file' in this.errors) {
                        this.currentState = this.states[2];
                        this.form.error = this.errors.import_file;
                    } else {
                        this.currentState = this.states[0];
                    }
                });
        },
        onSaveValidatedFile() {
            this.$store
                .dispatch('merchants/importFileById', {
                    id: this.unvalidatedMerchants.import_file_upload_id
                })
                .then((response) => {
                    this.form.per_page = response.total_imported_data;
                    if (this.form.per_page > 0) {
                        this.fileValidation.loading = false;
                        this.fileValidation.show = false;
                        this.currentState = this.states[0];

                        let classification = this.classification == 'BRANCH' ? 'Branches' : 'Merchants';
                        this.notification({ type: 'success', title: `${classification} - Batch Upload`, message: `Successfully imported ${classification} from CSV` });
                        // this.$router.push({
                        //     query: {
                        //         batch_number: this.form.batch_number,
                        //         per_page: this.form.per_page
                        //     }
                        // });
                    } else {
                        this.fileValidation.loading = false;
                    }
                });
        },
        onExtractErrors() {
            const fileName = 'import'; //this.form.fileList[0].name

            this.isExtractLoading = true;
            this.$store
                .dispatch('merchants/extractImportedFileError', {
                    id: this.unvalidatedMerchants.import_file_upload_id,
                    name: `${fileName}_errors`
                })
                .then(() => {
                    this.unvalidatedMerchants.total_invalid_data = 0;
                    this.isExtractLoading = false;
                })
                .catch(() => {
                    this.isExtractLoading = false;
                });
        },
        onDownloadAllQR() {
            const filter_uuids = [];
            Object.values(this.merchantsList.data).forEach((merchant) => {
                filter_uuids.push(merchant.uuid);
            });

            if (filter_uuids.length != 0) {
                // downloadMerchantsQR
                this.$store
                    .dispatch('merchants/processDownloadAsyncMerchantsQR', {
                        data: {
                            merchant_uuids: filter_uuids || undefined,
                            output_format: 'PDF'
                            // responseType: 'blob'
                        }
                    })
                    .then((response) => {
                        // Set encoded asyncTaskIDPoll
                        this.$cookies.set('asyncTaskIDPoll', window.btoa(response.data.id));
                        let classificationModule = this.classification == 'BRANCH' ? 'Branches' : 'Merchants';

                        // Set asyncTaskModule
                        this.$cookies.set('asyncTaskModule', classificationModule);

                        this.notification({
                            type: 'success',
                            title: `${classificationModule} - QR Download`,
                            message: 'QR Generation In-Progress. Please wait for the process to complete. Do not logout or close this window.'
                        });

                        this.$eventBus.$emit('check-merchants-qr-status');
                    })
                    .catch((error) => {
                        if (error.response && error.response.data) {
                            let text = [];
                            if (error.response.data.errors) {
                                let errors = Object.keys(error.response.data.errors);
                                // Loop each field with errors
                                errors.forEach((key) => {
                                    text = [...text, `${error.response.data.errors[key]} <br/>`];
                                });
                            }

                            let classification = this.classification == 'BRANCH' ? 'Branches' : 'Merchants';

                            this.$notify({
                                group: 'main-notifications',
                                type: 'error',
                                duration: 5000,
                                title: `${classification} - QR Download`,
                                text: text.length > 0 ? text.toString().replace(',', '') : error.response.data.data.message || error.response.data.message || error.response.statusText
                            });
                        }
                    });
            }
        }
    }
};
</script>

<style lang="scss" scoped>
.dashed-border {
    border: dashed #a0aec0 !important;
    border-width: 1px !important;
}

h2,
h4 {
    font-weight: 600;
}

.import-title {
    white-space: normal;
    word-break: break-all;
}

.guideline-box {
    background: #f1f4f6 !important;
    color: #1a202c;
}

.guideline-title {
    color: #83929b;
    font-weight: bold;
}

li.guidelines-list {
    padding-left: 0.5rem;
}

li.guidelines-list::marker {
    font-weight: bold;
}

.import-guide {
    text-decoration: none;

    &-header {
        color: #1a202c;
    }
}

.file-validation-details {
    color: #425466 !important;

    .file-validation-detail {
        display: flex;

        & div {
            margin: 5px 0;

            &:first-child {
                width: 35%;
            }
            &:last-child {
                width: 65%;
                font-weight: 500;
                color: #16192c;
            }
        }
    }
}

.confirm-dialog {
    & .v-icon.v-icon {
        font-size: 22px;
    }

    & .close-btn {
        color: rgba(90, 102, 120, 0.6);
    }
}

.error-dialog {
    .title-container {
        max-width: unset;
    }
}

.import-success-alert {
    position: absolute;
    bottom: 20px;
    right: 20px;
    z-index: 3;
    background-color: #20315c;
    border-radius: 16px !important;

    ::v-deep .v-alert__dismissible i {
        font-size: 16px;
        color: #a6adbe;
    }

    .time {
        color: #9faed7;
    }
}

.error-empty {
    min-height: 300px;
}

::v-deep table {
    color: #425466 !important;

    tr {
        th {
            color: #8492a6 !important;
        }

        td:first-child,
        td:nth-child(2) {
            font-weight: 600;
        }
    }

    &:hover {
        cursor: default;
    }
}

.speech-bubble {
    color: white !important;
    background: #373d3f;
    margin-left: 20px;
    margin-top: -20px;
    font-size: 12px;
    contain: initial;
    overflow: visible;

    &::before {
        position: absolute;
        content: '';
        position: absolute;
        top: 20px;
        left: -8px;
        width: 0;
        height: 0;
        border: 9px solid transparent;
        border-right-color: #373d3f;
        margin-left: -9px;
    }
}
</style>
